import React, { useState } from 'react';
import { MinusIcon } from '@chakra-ui/icons';
import {
  Box,
  useColorModeValue,
  HStack,
  Flex,
  Text,
  Slider,
  SliderTrack,
  SliderFilledTrack,
  SliderThumb,
} from '@chakra-ui/react';
import AppColors from '../../../constants/AppColors';
import { PlusIcon } from '../../../constants/IconData';
import { FONT_FAMILY } from '../../../constants/Theme';
import ExcelReader from './import_sheet/excel_reader';
import BatchChartNavigator from './BatchChartNavigator';

/**
 * Bottom bar of the audit sheet: batch/chart navigation on the left, sheet
 * import and zoom on the right.
 *
 * The sheet tabs that used to sit here are gone. Multiple sheets per chart were
 * never used in practice -- every audit sheet stays on "Sheet1", and nothing but
 * those tabs could create a second one (the Excel import overwrites the one
 * sheet rather than adding another) -- so the tabs only took up the space the
 * navigator now uses. `sheet_name` and `index` are still sent with every
 * update, so the backend contract is unchanged and per-chart sheets could be
 * restored without a migration.
 */
export default function AuditSheetFooter({
  onZoom,
  providerOptions,
  currentUpload,
  updateAuditSheet,
  view,
  batchId,
  currentChartId,
  isBatchView,
  onNavigateAway,
  isSaving,
  }) {
  const [sliderValue, setSliderValue] = useState(50);

  return (
    <Box w={'100%'} style={{zIndex:10}}>
      <Flex
        bg={AppColors.primary}
        color={useColorModeValue('gray.600', 'white')}
        minH={'60px'}
        width={'100%'}
        borderBottom={1}
        borderStyle={'solid'}
        borderColor={useColorModeValue('gray.200', 'gray.900')}
        align={'center'}
      >
        <Flex flex={{ base: 1 }} alignItems={'center'} pl={5} gap={4}>
          <BatchChartNavigator
            batchId={batchId}
            currentChartId={currentChartId}
            isBatchView={isBatchView}
            onNavigateAway={onNavigateAway}
            isSaving={isSaving}
          />
        </Flex >
        <HStack alignItems={'center'} gap={1} mr={10}>
          {!view && <ExcelReader updateAuditSheet={updateAuditSheet} providerOptions={providerOptions} currentUpload={currentUpload}/>}
          <MinusIcon style={{ width: 10, height: 10, display: 'inline-block',cursor:"pointer" }} onClick={()=> {setSliderValue(sliderValue-5)
            onZoom(sliderValue-5)}}/>
          <Slider
            justifyContent={'end'}
            aria-label="slider-ex-1"
            colorScheme="gray"
            defaultValue={50}
            width={100}
            value={sliderValue}
            min={0}
            max={100}
            onChange={v => {
              onZoom(v)
              setSliderValue(v)
            }}
          >
            <SliderTrack>
              <SliderFilledTrack />
            </SliderTrack>
            <SliderThumb />
          </Slider>
          <PlusIcon style={{ width: 10, height: 10, display: 'inline-block',cursor:"pointer" }} onClick={()=> {setSliderValue(sliderValue+5)
          onZoom(sliderValue+5)}}/>
          <Text fontFamily={FONT_FAMILY.ptSans} fontSize="sm" color="white" >
            {sliderValue}
          </Text>
        </HStack>
      </Flex>

    </Box >
  );
}
